import { useEffect, useState, useRef } from "react";
import { chatService, authService, formService } from "../service";

export const useNotifications = (userId) => {
  const [messageNotifs, setMessageNotifs] = useState([]);
  const [responseNotifs, setResponseNotifs] = useState([]);
  const wsRef = useRef(null);

  const userCache = useRef({});
  const formCache = useRef({});

  useEffect(() => {
    if (!userId || wsRef.current) return; 
    const ws = chatService.connectSocket(userId);
    wsRef.current = ws;

    ws.onopen = () => console.log(" WebSocket connecté (global)");
    ws.onclose = () => console.warn(" WebSocket fermé");
    ws.onerror = (e) => console.error(" WebSocket erreur:", e);

    ws.onmessage = async (event) => {
      try {
        const data = JSON.parse(event.data);
        if (data.type === "notification" && data.subtype === "chat_message") {
          try {
            let fullName;
            if (userCache.current[data.from]) {
              fullName = userCache.current[data.from];
            } else {
              const res = await authService.getUserById(data.from);
              const u = res.data;
              fullName = `Dr. ${u.first_name} ${u.last_name}`;
              userCache.current[data.from] = fullName;
            }

            setMessageNotifs((prev) => [
              {
                from: fullName,
                content: data.content,
                created_at: data.created_at,
              },
              ...prev,
            ]);
          } catch (err) {
            console.error("Erreur user:", err);
          }
        }

        // Form response notifications
        else if (
          data.type === "notification" &&
          data.subtype === "form_response"
        ) {
          try {
            //  Get user name
            let submitterName;
            if (userCache.current[data.submitted_by]) {
              submitterName = userCache.current[data.submitted_by];
            } else {
              const res = await authService.getUserById(data.submitted_by);
              const u = res.data;
              submitterName = `Dr. ${u.first_name} ${u.last_name}`;
              userCache.current[data.submitted_by] = submitterName;
            }

            //  Get form title
            let formTitle;
            if (formCache.current[data.form_id]) {
              formTitle = formCache.current[data.form_id];
            } else {
              const res = await formService.getById(data.form_id); 
              formTitle = res.data.title || "Formulaire inconnu";
              formCache.current[data.form_id] = formTitle;
            }

            setResponseNotifs((prev) => [
              {
                formTitle,
                submitted_by: submitterName,
                created_at: data.created_at,
              },
              ...prev,
            ]);
          } catch (err) {
            console.error("Erreur form/user:", err);
          }
        }
      } catch (err) {
        console.error("Message WebSocket invalide:", err);
      }
    };

    return () => {
      // Do NOT close here — only close when user logs out
    };
  }, [userId]);

  return { messageNotifs, responseNotifs, setMessageNotifs, setResponseNotifs };
};
